import { CognitoUserPool } from 'amazon-cognito-identity-js';
import * as Endpoints from 'constants/endpoints.constant';

const poolData: any = {
  UserPoolId: Endpoints.cognito.UserPoolId,
  ClientId: Endpoints.cognito.ClientId,
};

const entPoolData: any = {
  UserPoolId: Endpoints.ent_cognito.userPoolId,
  ClientId: Endpoints.ent_cognito.clientSecret,
};

export const UserPool = new CognitoUserPool(poolData);
export const EntUserPool = new CognitoUserPool(entPoolData);
